import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing, palette }: any) => ({
  arrowBack: {
    marginLeft: -spacing(1.25),
  },
  increasedHeader: {
    height: spacing(10),
  },
  header: {
    backgroundColor: palette.primary.main,
    padding: `${spacing(2)}px ${spacing(5)}px`,
  },
}));
